"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _reactWaypoint = require("react-waypoint");

var _immutable = require("immutable");

var _reactPolyglot = require("react-polyglot");

var _collections = require("../../../reducers/collections");

var _publishModes = require("../../../constants/publishModes");

var _EntryCard = _interopRequireDefault(require("./EntryCard"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const CardsGrid = (0, _styledBase.default)("ul", {
  target: "e1hbvtjf0",
  label: "CardsGrid"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

class EntryListing extends _react.default.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "hasMore", () => {
      var _this$props$cursor, _this$props$cursor$ac;

      const hasMore = (_this$props$cursor = this.props.cursor) === null || _this$props$cursor === void 0 ? void 0 : (_this$props$cursor$ac = _this$props$cursor.actions) === null || _this$props$cursor$ac === void 0 ? void 0 : _this$props$cursor$ac.has('append_next');
      return hasMore;
    });

    _defineProperty(this, "handleLoadMore", () => {
      if (this.hasMore()) {
        this.props.handleCursorActions('append_next');
      }
    });

    _defineProperty(this, "handleChangeStatus", (newStatus, dragProps) => {
      const slug = dragProps.slug;
      const collection = dragProps.collection;
      const oldStatus = dragProps.status;
      this.props.handleChangeStatus(collection, slug, oldStatus, newStatus);
    });

    _defineProperty(this, "requestDelete", (collection, slug, ownStatus) => {
      if (window.confirm(this.props.t(ownStatus ? 'editor.editor.onDeleteUnpublishedChanges' : 'editor.editor.onDeletePublishedEntry'))) {
        this.props.handleDelete(collection, slug, ownStatus).then(() => window.location.reload());
      }
    });

    _defineProperty(this, "requestPublish", (collection, slug, ownStatus) => {
      if (ownStatus !== _publishModes.status.last()) {
        window.alert(this.props.t('editor.editor.onPublishingNotReady'));
        return;
      } else if (!window.confirm(this.props.t('editor.editor.onPublishing'))) {
        return;
      }

      this.props.handlePublish(collection, slug).then(() => window.location.reload());
    });

    _defineProperty(this, "inferFields", collection => {
      const titleField = (0, _collections.selectInferedField)(collection, 'title');
      const descriptionField = (0, _collections.selectInferedField)(collection, 'description');
      const imageField = (0, _collections.selectInferedField)(collection, 'image');
      const fields = (0, _collections.selectFields)(collection);
      const inferedFields = [titleField, descriptionField, imageField];
      const remainingFields = fields && fields.filter(f => inferedFields.indexOf(f.get('name')) === -1);
      return {
        titleField,
        descriptionField,
        imageField,
        remainingFields
      };
    });

    _defineProperty(this, "renderCardsForSingleCollection", () => {
      const {
        collections,
        entries,
        viewStyle
      } = this.props;
      const inferedFields = this.inferFields(collections);
      const entryCardProps = {
        collection: collections,
        inferedFields,
        viewStyle,
        handleChangeStatus: this.handleChangeStatus
      };
      return entries.map((entry, idx) => {
        const collectionName = entry.get('collection');
        const ownStatus = entry.get('status');
        const slug = entry.get('slug');
        const data = entry.get('data');
        const previewLink = data.interactiveIds ? data.interactiveIds[0] : slug;
        entryCardProps.slug = previewLink;
        entryCardProps.handlePublish = this.requestPublish.bind(this, collectionName, slug, ownStatus);
        entryCardProps.handleDelete = this.requestDelete.bind(this, collectionName, slug, ownStatus);
        entryCardProps.status = entry.get('status') ? entry.get('status') : 'published';
        entryCardProps.lastAuthored = entry.get('author');
        entryCardProps.lastUpdated = entry.get('updatedOn');
        entryCardProps.lastPublished = entry.get('publishedOn');
        let cardColor = '#caef6f';

        switch (entryCardProps.status) {
          case 'draft':
            cardColor = '#f6d8ff';
            break;

          case 'pending_publish':
            cardColor = '#ffee9c';
            break;
        }

        return (0, _core.jsx)(_EntryCard.default, _extends({
          style: {
            backgroundColor: cardColor
          }
        }, entryCardProps, {
          entry: entry,
          key: idx
        }));
      });
    });

    _defineProperty(this, "renderCardsForMultipleCollections", () => {
      const {
        collections,
        entries
      } = this.props;
      const isSingleCollectionInList = collections.size === 1;
      return entries.map((entry, idx) => {
        const collectionName = entry.get('collection');
        const collection = collections.find(coll => coll.get('name') === collectionName);
        const collectionLabel = !isSingleCollectionInList && collection.get('label');
        const inferedFields = this.inferFields(collection);
        const entryStatus = 'published';
        const lastAuthored = entry.get('author');
        const lastUpdated = entry.get('updatedOn');
        const lastPublished = entry.get('publishedOn');
        const entryCardProps = {
          collection,
          entry,
          inferedFields,
          collectionLabel,
          entryStatus,
          lastAuthored,
          lastUpdated,
          lastPublished
        };
        return (0, _core.jsx)(_EntryCard.default, _extends({}, entryCardProps, {
          key: idx
        }));
      });
    });
  }

  render() {
    const {
      collections,
      page
    } = this.props;
    return (0, _core.jsx)("div", null, (0, _core.jsx)(CardsGrid, null, _immutable.Map.isMap(collections) ? this.renderCardsForSingleCollection() : this.renderCardsForMultipleCollections(), this.hasMore() && (0, _core.jsx)(_reactWaypoint.Waypoint, {
      key: page,
      onEnter: this.handleLoadMore
    })));
  }

}

exports.default = EntryListing;

_defineProperty(EntryListing, "propTypes", {
  collections: _reactImmutableProptypes.default.iterable.isRequired,
  entries: _reactImmutableProptypes.default.list,
  unpublishedEntries: _reactImmutableProptypes.default.list,
  viewStyle: _propTypes.default.string,
  cursor: _propTypes.default.any.isRequired,
  handleCursorActions: _propTypes.default.func.isRequired,
  handleChangeStatus: _propTypes.default.func.isRequired,
  handlePublish: _propTypes.default.func.isRequired,
  handleDelete: _propTypes.default.func.isRequired,
  page: _propTypes.default.number,
  t: _propTypes.default.func.isRequired
});